import { add } from './add';
import { createInstance } from './createInstance';
import { find } from './find';
import { findById } from './findById';
import { findEarliest } from './findEarliest';
import { remove } from './remove';
import { removeInstanceFromSeries } from './removeInstanceFromSeries';
import { search } from './search';
import { searchUnderwriters } from './searchUnderwriters';
import { update } from './update';

export const trafficAPI = {
  add,
  createInstance,
  find,
  findById,
  findEarliest,
  remove,
  removeInstanceFromSeries,
  search,
  searchUnderwriters,
  update,
};
